// src/utils/deviceInfo.js
import UAParser from 'ua-parser-js'

class DeviceInfo {
    /**
     * 获取设备信息
     */
    static getDeviceInfo() {
        const parser = new UAParser()
        const result = parser.getResult()

        return {
            // 浏览器信息
            browser: {
                name: result.browser.name || '',
                version: result.browser.version || '',
                major: result.browser.major || ''
            },

            // 操作系统信息
            os: {
                name: result.os.name || '',
                version: result.os.version || ''
            },

            // 设备信息
            device: {
                model: result.device.model || '',
                type: result.device.type || '',
                vendor: result.device.vendor || ''
            },

            // CPU架构
            cpu: {
                architecture: result.cpu.architecture || ''
            },

            // 引擎信息
            engine: {
                name: result.engine.name || '',
                version: result.engine.version || ''
            },

            // 原始UA
            ua: parser.getUA(),

            // 屏幕信息
            screen: {
                width: window.screen.width,
                height: window.screen.height,
                colorDepth: window.screen.colorDepth,
                pixelRatio: window.devicePixelRatio,
                orientation: this.getScreenOrientation()
            },

            // 浏览器环境
            environment: {
                language: navigator.language || navigator.userLanguage || '未知',
                languages: navigator.languages || [],
                cookiesEnabled: navigator.cookieEnabled,
                online: navigator.onLine,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                platform: navigator.platform
            },

            // 网络信息
            network: this.getNetworkInfo(),

            // 页面信息
            page: {
                url: window.location.href,
                referrer: document.referrer || '直接访问'
            }
        }
    }

    /**
     * 获取屏幕方向
     */
    static getScreenOrientation() {
        if (window.screen.orientation) {
            return window.screen.orientation.type
        } else if (window.orientation !== undefined) {
            return window.orientation === 0 ? 'portrait-primary' : 'landscape-primary'
        }
        return '未知'
    }

    /**
     * 获取网络信息
     */
    static getNetworkInfo() {
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection

        if (!connection) {
            return {
                effectiveType: '未知',
                downlink: 0,
                rtt: 0,
                saveData: false
            }
        }

        return {
            effectiveType: connection.effectiveType || '未知',
            downlink: connection.downlink || 0,
            rtt: connection.rtt || 0,
            saveData: connection.saveData || false
        }
    }

    /**
     * 判断是否为移动设备
     */
    static isMobile() {
        const parser = new UAParser()
        const result = parser.getResult()
        return result.device.type === 'mobile' || result.device.type === 'tablet'
    }

    /**
     * 获取设备指纹（简易版）
     */
    static getDeviceFingerprint() {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        const txt = '设备指纹@' + Date.now()

        ctx.textBaseline = 'top'
        ctx.font = "14px 'Arial'"
        ctx.textBaseline = 'alphabetic'
        ctx.fillStyle = '#f60'
        ctx.fillRect(125, 1, 62, 20)
        ctx.fillStyle = '#069'
        ctx.fillText(txt, 2, 15)
        ctx.fillStyle = 'rgba(102, 204, 0, 0.7)'
        ctx.fillText(txt, 4, 17)

        return canvas.toDataURL()
    }
}

export default DeviceInfo
